/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ClassStudentNotificationViewModel } from "../types/ClassStudentNotificationViewModel.ts";

export const classStudentNotificationViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("Identificador único da turma.")),
  code: z.string().describe("Código interno da turma.").nullish(),
  name: z.string().describe("Nome descritivo da turma.").nullish(),
  totalEnrolled: z.optional(
    z.number().int().describe("Total de alunos matriculados na turma."),
  ),
}) as unknown as ToZod<ClassStudentNotificationViewModel>;
